import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Share from '../components/Share';
import JobIllustration from '../components/JobIllustration';
import './Jobs.css';
import voiceJobs from '../data/readingJobs';
import { calculateVoiceQuote } from '../utils/voicePricing';
import { yen } from '../components/VoiceCalculator';

function Jobs() {
  return (
    <div className="body jobs-frame">
      <Header
        title="Jobs・仕事一覧 | ASMRキリスト教会"
        description="ASMRキリスト教会の仕事・募集一覧。オンライン礼拝の声優、エゼキエル書33〜48章と説教の朗読を募集しています。"
        url="https://www.asmrchurch.com/jobs"
        image="https://www.asmrchurch.com/static/images/jobs/index-og.jpg"
        subon={false}
      />
      <main className="jobs-page">
        <header className="jobs-hero">
          <p className="jobs-eyebrow">Jobs</p>
          <h1>仕事一覧</h1>
          <p className="jobs-intro">ASMRキリスト教会で、いっしょに活動してくださる方を募集しています。</p>
          <img
            className="jobs-hero-image"
            src="/static/images/kirikan2-santa-jobs.png"
            alt="ミニスカサンタ姿で白い袋から札束を取り出し、ウィンクするキリ看ちゃん"
            width="1536"
            height="1024"
          />
        </header>
        <section className="jobs-section" aria-labelledby="voice-openings">
          <h2 id="voice-openings">聖書・説教の朗読募集</h2>
          <p>エゼキエル書第33〜48章をまとめた5案件と、説教の朗読を募集します。各案件の原稿・報酬を確認して応募できます。動画は顔出し不要ですが、体の撮影が必要です。</p>
          <div className="jobs-card-list">{voiceJobs.map(job => {
            const quote = calculateVoiceQuote(job.text);
            return (
              <a className="jobs-card" href={job.path} key={job.chapter}>
                <JobIllustration job={job} />
                <div className="jobs-card-content">
                  <p className="jobs-eyebrow">募集中 / {job.kind === 'bible' ? '聖書朗読' : '説教朗読'}</p>
                  <h3>{job.title}</h3>
                  <p>{quote.count.toLocaleString('ja-JP')}文字 / 1文字1.5円</p>
                  <p className="jobs-card-price">{yen(quote.base)}〜</p>
                  <p className="jobs-note">税込・源泉徴収前 / オプション加算あり</p>
                  <span className="jobs-card-link">原稿・詳細・応募 →</span>
                </div>
              </a>
            );
          })}</div>
        </section>
        <section aria-labelledby="jobs-openings">
          <h2 id="jobs-openings">募集中の仕事</h2>
          <a className="jobs-card" href="/jobs/voice-actor">
            <img
              className="jobs-card-image"
              src="/static/images/kirikan-jobs-studio-amen.png"
              alt=""
              width="1536"
              height="1024"
            />
            <div className="jobs-card-content">
              <p className="jobs-eyebrow">募集中・2名</p>
              <h3>声優・オンライン礼拝の司会進行／出演</h3>
              <p>日曜日・月4回 / 1回1時間程度</p>
              <p>月額10,000円（能力に応じて応相談） / 契約期間1年</p>
              <p className="jobs-note">PC貸与あり</p>
              <span className="jobs-card-link">募集詳細を見る →</span>
            </div>
          </a>
        </section>
        <div className="jobs-share">
          <Share hashtags={['声優募集', '有償依頼', '有償']}
            label="仕事一覧をシェアする"
            title="Jobs・仕事一覧 | ASMRキリスト教会"
            url="https://www.asmrchurch.com/jobs"
            text="ASMRキリスト教会で、いっしょに活動してくださる方を募集しています。"
            image="https://www.asmrchurch.com/static/images/jobs/index-og.jpg"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Jobs;
